import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiEditorPageHeaderComponent } from './fi-editor-page-header.component';
import { FiAppTextSharedModule } from '../app-text';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, MatButtonModule, MatMenuModule, MatIconModule],
    declarations: [FiEditorPageHeaderComponent],
    exports: [FiEditorPageHeaderComponent],
})
export class FiEditorPageHeaderModule {}
